/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeLanguage } from './CodeLanguage';
import {
    CodeLanguageFromJSON,
    CodeLanguageFromJSONTyped,
    CodeLanguageToJSON,
    CodeLanguageToJSONTyped,
} from './CodeLanguage';
import type { JudgingState } from './JudgingState';
import {
    JudgingStateFromJSON,
    JudgingStateFromJSONTyped,
    JudgingStateToJSON,
    JudgingStateToJSONTyped,
} from './JudgingState';
import type { FeedbackLevel } from './FeedbackLevel';
import {
    FeedbackLevelFromJSON,
    FeedbackLevelFromJSONTyped,
    FeedbackLevelToJSON,
    FeedbackLevelToJSONTyped,
} from './FeedbackLevel';
import type { SubmissionResultReadFull } from './SubmissionResultReadFull';
import {
    SubmissionResultReadFullFromJSON,
    SubmissionResultReadFullFromJSONTyped,
    SubmissionResultReadFullToJSON,
    SubmissionResultReadFullToJSONTyped,
} from './SubmissionResultReadFull';

/**
 * 
 * @export
 * @interface SubmissionReadFull
 */
export interface SubmissionReadFull {
    /**
     * 
     * @type {string}
     * @memberof SubmissionReadFull
     */
    problem_id: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionReadFull
     */
    competitor_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionReadFull
     */
    code: string;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionReadFull
     */
    created_at?: Date | null;
    /**
     * 
     * @type {CodeLanguage}
     * @memberof SubmissionReadFull
     */
    language: CodeLanguage;
    /**
     * 
     * @type {string}
     * @memberof SubmissionReadFull
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SubmissionReadFull
     */
    points: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionReadFull
     */
    user_id: string | null;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof SubmissionReadFull
     */
    feedback?: FeedbackLevel;
    /**
     * 
     * @type {JudgingState}
     * @memberof SubmissionReadFull
     */
    judging?: JudgingState | null;
    /**
     * 
     * @type {Array<SubmissionResultReadFull>}
     * @memberof SubmissionReadFull
     */
    results: Array<SubmissionResultReadFull>;
}



/**
 * Check if a given object implements the SubmissionReadFull interface.
 */
export function instanceOfSubmissionReadFull(value: object): value is SubmissionReadFull {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function SubmissionReadFullFromJSON(json: any): SubmissionReadFull {
    return SubmissionReadFullFromJSONTyped(json, false);
}

export function SubmissionReadFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionReadFull {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'competitor_id': json['competitor_id'] == null ? undefined : json['competitor_id'],
        'code': json['code'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'language': CodeLanguageFromJSON(json['language']),
        'id': json['id'],
        'points': json['points'],
        'user_id': json['user_id'],
        'feedback': json['feedback'] == null ? undefined : FeedbackLevelFromJSON(json['feedback']),
        'judging': json['judging'] == null ? undefined : JudgingStateFromJSON(json['judging']),
        'results': ((json['results'] as Array<any>).map(SubmissionResultReadFullFromJSON)),
    };
}

export function SubmissionReadFullToJSON(json: any): SubmissionReadFull {
    return SubmissionReadFullToJSONTyped(json, false);
}

export function SubmissionReadFullToJSONTyped(value?: SubmissionReadFull | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'competitor_id': value['competitor_id'],
        'code': value['code'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at'] as any).toISOString()),
        'language': CodeLanguageToJSON(value['language']),
        'id': value['id'],
        'points': value['points'],
        'user_id': value['user_id'],
        'feedback': FeedbackLevelToJSON(value['feedback']),
        'judging': JudgingStateToJSON(value['judging']),
        'results': ((value['results'] as Array<any>).map(SubmissionResultReadFullToJSON)),
    };
}

